import actionTypes from '../constant/constants';


export function changeState(updatevalue) {
    return dispatch => {
        dispatch({type: actionTypes.USER_NAME, payload: updatevalue})
    }
}

export const setCurrentLocation = (location) => {
    return dispatch => {
        dispatch({type: actionTypes.CURRENT_LOCATION, payload: location})
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/action.js